var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignpost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 1.6665H7.46671C7.13337 1.6665 6.81668 1.78317 6.55835 1.98317L4.73335 3.44151C4.00002 4.02484 4.00002 5.13316 4.73335 5.71649L6.55835 7.17482C6.81668 7.38316 7.14171 7.4915 7.46671 7.4915H14.35C15.1583 7.4915 15.8083 6.8415 15.8083 6.03316V3.1165C15.8083 2.3165 15.1583 1.6665 14.35 1.6665Z",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66665 10H12.55C12.8833 10 13.2 10.1167 13.4583 10.3167L15.2833 11.775C16.0167 12.3583 16.0167 13.4667 15.2833 14.05L13.4583 15.5083C13.2 15.7167 12.875 15.825 12.55 15.825H5.66665C4.85831 15.825 4.20831 15.175 4.20831 14.3667V11.45C4.20831 10.65 4.85831 10 5.66665 10Z",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10V7.5",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3335V15.8335",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.3335H12.5",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignpost);
export default __webpack_public_path__ + "static/media/signpost.ccbc9631882df709e4a8f6822da8904f.svg";
export { ForwardRef as ReactComponent };